<template>
  <div class="vehicle-schedule-main">
    <div class="gantt-container" ref="gantt-container" :style="{ maxWidth: showHmsTrip ? 'calc(100% - 425px)' : '100%' }">
      <div class="date-container">
        <div class="date-title">Show timeline</div>
        <DateTimePicker placeholder="from" :value.sync="startDate" />
        <DateTimePicker placeholder="to" :value.sync="endDate" />
        <div class="refresh-container">
          <button @click="showRefreshDropdown = !showRefreshDropdown">{{ refreshText }}</button>
          <div v-if="showRefreshDropdown" class="refresh-dropdown">
            <div>Refresh Every:</div>
            <button @click="refreshIntervalClicked($event, 10)">10 seconds</button>
            <button @click="refreshIntervalClicked($event, 30)">30 seconds</button>
            <button @click="refreshIntervalClicked($event, 300)">5 minutes</button>
            <button @click="refreshIntervalClicked($event, 600)">10 minutes</button>
            <button @click="refreshIntervalClicked($event, 1800)">30 minutes</button>
            <button @click="refreshIntervalClicked($event, 3600)">1 hour</button>
            <button class="refresh-now" @click="refreshIntervalClicked($event, null)">Refresh Now</button>
            <button v-if="refreshInterval" class="cancel-refresh" @click="refreshIntervalClicked(null, null)">Cancel Refresh</button>
          </div>
        </div>
        <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
      </div>
      <div class="gantt-with-legends">
        <GanttChartV2 :items="ganttItems" @taskClicked="ganttTaskClicked" @rowClicked="ganttRowClicked" :timeZoneWidth.sync="ganttMainWidth"/>
        <div class="gantt-legends">
          <div class="gantt-legends-items" v-for="(l, i) in legendsItems" :key="i">
            <div class="gantt-legends-color" :style="{ backgroundColor: l['ColorHexa'] }"></div>
            <div>{{ l['ColorDesc'] }}</div>
          </div>
        </div>
      </div>
      <Loader class="gantt-loader" :loadingText="loadText" :isVisible.sync="loading"/>
    </div>
    <div class="hms-trip-container" :style="{ minWidth: showHmsTrip ? '420px' : '0', padding: showHmsTrip ? '5px' : '0' }">
      <div class="hms-title" style=" width: 100%; display: flex;  justify-content: space-between; align-items: center;" :style="{ 'background-color': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? '#42a81d' : '#f24a01')}">
        <div class="header-back-button" v-if="consignmentDetails || (consignmentSelection['show'] || consignmentSelection['select'] != '')" @click="hideConsignmentDetails()">ᐊ
        </div>
        <div style="width: calc(100% - 30px); overflow:hidden; text-overflow: ellipsis; white-space: nowrap; user-select: none;">{{ consignmentDetails ? `${(consignmentDetails['ConsignmentNo'] ? consignmentDetails['ConsignmentNo'].trim() : '')} - ${(consignmentDetails['PMNo'] ? consignmentDetails['PMNo'].trim() : '')} [${(consignmentDetails['Driver'] ? consignmentDetails['Driver'].trim() : '')}]` : (consignmentSelection['show'] || consignmentSelection['select'] != '') ? ((consignmentSelection['select'] != '') ? ('Select ' + consignmentSelection['select'] + ' job') : (`${mode} - ${hmsTitle}`)) : hmsTitle }}
        </div>
        <img @click="showHmsTrip = false;" src="https://dsmlib.logistics.systems/Icons/error.png" style="width: 15px; height: 15px; background-color: white; border-radius: 50%; cursor: pointer;" alt="">
      </div>
      <div class="hms-body">
        <div v-if="hmsLoading" class="loading-hms-trips">Loading Trips . . .</div>
        <div v-if="hmsTrips.length > 0 && !consignmentDetails && !consignmentSelection['show']" class="hms-trips-container">
          <div v-for="(h, i) in hmsTrips" :key="i" class="hms-trips-content" @click="hmsBtn('tripClicked', h)" :style="{
            'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : ''),
            'display': hmsHideTrip(h) ? 'none' : ''}" style="position: relative;">
            <div class="trips-row">
              <div class="trips-left">{{ h['ContainerNo'] }}</div>
              <div class="trips-right">{{ h['ContSize'] }}{{ h['ContType'] ? h['ContType'].trim() : '' }}</div>
            </div>
            <div class="trips-row">
              <div class="trips-left">{{ h['ConsignmentNo'] ? h['ConsignmentNo'].trim() : '' }}</div>
              <div class="trips-right">{{ h['MovementType'] }}</div>
            </div>
            <div class="trips-row">
              <div class="trips-left">{{ h['BillToName'] ? h['BillToName'].trim() : '' }}</div>
              <div class="trips-right">[{{ h['FromDestCode'] ? h['FromDestCode'].trim() : '' }} ({{ h['FromArea'] ? h['FromArea'].trim() : '' }}) - {{ h['ToDestCode'] ? h['ToDestCode'].trim() : '' }} ({{ h['ToArea'] ? h['ToArea'].trim() : '' }})]</div>
            </div>
            <Tooltip v-if="h['PickupIn']" style="position: absolute; top: 3px; right: 3px;" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
              <img style="width: 20px; height: 20px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
              <div slot="tooltipText">
                <span>Next Action : {{(h['DropoffIn'] ? 'Drop Off Out' : (h['PickupOut'] ? 'Drop Off In' : (h['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
              </div>
            </Tooltip>
            <Tooltip style="position: absolute; top: 30%; right: 3px;" v-if="h['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="300">
              <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
              <div slot="tooltipText">
                <span>Port/Depot Bkg : {{ `${!h['cmbookid'] || h['cmbookid'].trim() == '' ? '-' : h['cmbookid']} by ${!h['cmbookuser'] || h['cmbookuser'].trim() == '' ? '-' : h['cmbookuser']}` }}</span>
                <br>
                <span>Bkg Remarks : {{ !h['cmbookremarks'] || h['cmbookremarks'].trim() == '' ? '' : h['cmbookremarks'] }}</span>
              </div>
            </Tooltip>
            <Tooltip @click.native="showConsignmentDetails(h)" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
          </div>

        </div>
        <div v-if="consignmentDetails" class="consignment-details">
            <div class="consignment-row">
              <div class="consignment-label">Trip #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['JINo'] || consignmentDetails['JINo'].trim() == '' ? '-' : consignmentDetails['JINo']}}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['consignmentDetails'] || consignmentDetails['MovementType'].trim() == '' ? '-' : consignmentDetails['MovementType'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Cust</div>
              <div class="consignment-details-left">{{ !consignmentDetails['BillToName'] || consignmentDetails['BillToName'].trim() == '' ? '-' : consignmentDetails['BillToName']}}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Cont #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['ContainerNo'] || consignmentDetails['ContainerNo'].trim() == '' ? '-' : consignmentDetails['ContainerNo'] }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ContSize'] }}{{ consignmentDetails['ContType'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BContainerNo'] || consignmentDetails['B2BContainerNo'].trim() == '' ? '-' : consignmentDetails['B2BContainerNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B CN</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BConsignmentNo'] || consignmentDetails['B2BConsignmentNo'].trim() == '' ? '-': consignmentDetails['B2BConsignmentNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Bkg Ref</div>
              <div class="consignment-details-left">{{ consignmentDetails['BookingRefNo'] ? consignmentDetails['BookingRefNo'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ShipCall_No'] ? consignmentDetails['ShipCall_No'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">From</div>
              <div class="consignment-details-left">{{ consignmentDetails['FromDestCode'] ? consignmentDetails['FromDestCode'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['FromArea'] ? consignmentDetails['FromArea'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Tel #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['FromTelNo1'] || consignmentDetails['FromTelNo1'].trim() == '' ? '-' : consignmentDetails['FromTelNo1'] }}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['FromTelNo2'] || consignmentDetails['FromTelNo2'].trim() == '' ? '-' : consignmentDetails['FromTelNo2'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Address</div>
              <div class="consignment-details-left" v-html="formatConsignmentDetailsAddress('From')"></div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">To</div>
              <div class="consignment-details-left">{{ consignmentDetails['ToDestCode'] ? consignmentDetails['ToDestCode'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ToArea'] ? consignmentDetails['ToArea'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Tel #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['ToTelNo1'] || consignmentDetails['ToTelNo1'].trim() == '' ? '-' : consignmentDetails['ToTelNo1']  }}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['ToTelNo2'] || consignmentDetails['ToTelNo2'].trim() == '' ? '-' : consignmentDetails['ToTelNo2'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Address</div>
              <div class="consignment-details-left" v-html="formatConsignmentDetailsAddress('To')"></div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B To</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BToDestCode'] || consignmentDetails['B2BToDestCode'].trim() == '' ? '-' : consignmentDetails['B2BToDestCode'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Operator</div>
              <div class="consignment-details-left">{{ !consignmentDetails['Operator'] || consignmentDetails['Operator'].trim() == '' ? '-' : consignmentDetails['Operator']  }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Port/Depot Bkg</div>
              <div class="consignment-details-left">{{ `${!consignmentDetails['cmbookid'] || consignmentDetails['cmbookid'].trim() == '' ? '-' : consignmentDetails['cmbookid']} by ${!consignmentDetails['cmbookuser'] || consignmentDetails['cmbookuser'].trim() == '' ? '-' : consignmentDetails['cmbookuser']}` }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Bkg Remarks</div>
              <div class="consignment-details-left">{{ !consignmentDetails['cmbookremarks'] || consignmentDetails['cmbookremarks'].trim() == '' ? '-' : consignmentDetails['cmbookremarks'] }}</div>
            </div>
        </div>
        <div class="consignment-selection" v-if="consignmentSelection['show'] && !consignmentDetails">
          <div class="consignment">
            <div class="title">
              <div class="text">{{consignmentSelection['upperLabel']}}</div>
              <div class="cancel" @click="hmsBtn('portreset', 'upper')" :style="{ 'pointer-events': (consignmentSelection['upperSelected'] ? '' : 'none'), 'color': (consignmentSelection['upperSelected'] ? '' : '#fff3') }">&#9587;</div>
            </div>
            <div class="content">
              <div class="hms-trips-content" v-if="consignmentSelection['upperSelected']" :style="{
                'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}"
                 @click="hmsBtn('showTrips', 'upper')">
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['upperSelected']['ContainerNo'] ? consignmentSelection['upperSelected']['ContainerNo'].trim() : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['upperSelected']['ContSize'] ? consignmentSelection['upperSelected']['ContSize'].trim() : '' }}{{ consignmentSelection['upperSelected']['ContType'] ? consignmentSelection['upperSelected']['ContType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['upperSelected']['ConsignmentNo'] ? consignmentSelection['upperSelected']['ConsignmentNo'].trim() : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['upperSelected']['MovementType'] ? consignmentSelection['upperSelected']['MovementType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['upperSelected']['BillToName'] ? consignmentSelection['upperSelected']['BillToName'].trim() : '' }}</div>
                  <div class="trips-right">[{{ consignmentSelection['upperSelected']['FromDestCode'] ? consignmentSelection['upperSelected']['FromDestCode'].trim() : '' }} ({{ consignmentSelection['upperSelected']['FromArea'] ? consignmentSelection['upperSelected']['FromArea'].trim() : '' }}) - {{ consignmentSelection['upperSelected']['ToDestCode'] ? consignmentSelection['upperSelected']['ToDestCode'].trim() : '' }} ({{ consignmentSelection['upperSelected']['ToArea'] ? consignmentSelection['upperSelected']['ToArea'].trim() : '' }})]</div>
                </div>
                <Tooltip @click.native="showConsignmentDetails(consignmentSelection['upperSelected'])" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
              </div>
              <div class="noselect" @click="hmsBtn('showTrips', 'upper')" v-else>Click to select</div>
              <div class="errMsg" v-if="consignmentSelection['upperMsg']['errMsg']" :style="{ 
                'background-color': (consignmentSelection['upperMsg']['status'] > 0 ? '' : '#b3ffc7'),
                'border': (consignmentSelection['upperMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                {{ consignmentSelection['upperMsg']['errMsg'] }}
              </div>
            </div>
          </div>
          <div class="consignment">
            <div class="title">
              <div class="text">{{consignmentSelection['lowerLabel']}}</div>
              <div class="cancel" @click="hmsBtn('portreset', 'lower')" :style="{ 'pointer-events': (consignmentSelection['lowerSelected'] ? '' : 'none'), 'color': (consignmentSelection['lowerSelected'] ? '' : '#fff3') }">&#9587;</div>
            </div>
            <div class="content">
              <div class="hms-trips-content" v-if="consignmentSelection['lowerSelected']" :style="{
                'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}"
                 @click="hmsBtn('showTrips', 'lower')">
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['lowerSelected']['ContainerNo'] ? consignmentSelection['lowerSelected']['ContainerNo'].trim() : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['lowerSelected']['ContSize'] ? consignmentSelection['lowerSelected']['ContSize'].trim() : '' }}{{ consignmentSelection['lowerSelected']['ContType'] ? consignmentSelection['lowerSelected']['ContType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['lowerSelected']['ConsignmentNo'] ? consignmentSelection['lowerSelected']['ConsignmentNo'].trim() : '' }}</div>
                  <div class="trips-right">{{ consignmentSelection['lowerSelected']['MovementType'] ? consignmentSelection['lowerSelected']['MovementType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ consignmentSelection['lowerSelected']['BillToName'] ? consignmentSelection['lowerSelected']['BillToName'].trim() : '' }}</div>
                  <div class="trips-right">[{{ consignmentSelection['lowerSelected']['FromDestCode'] ? consignmentSelection['lowerSelected']['FromDestCode'].trim() : '' }} ({{ consignmentSelection['lowerSelected']['FromArea'] ? consignmentSelection['lowerSelected']['FromArea'].trim() : '' }}) - {{ consignmentSelection['lowerSelected']['ToDestCode'] ? consignmentSelection['lowerSelected']['ToDestCode'].trim() : '' }} ({{ consignmentSelection['lowerSelected']['ToArea'] ? consignmentSelection['lowerSelected']['ToArea'].trim() : '' }})]</div>
                </div>
                <Tooltip @click.native="showConsignmentDetails(consignmentSelection['lowerSelected'])" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"></Tooltip>
              </div>
              <div class="noselect" @click="hmsBtn('showTrips', 'lower')" v-else>Click to select</div>
              <div class="errMsg" v-if="consignmentSelection['lowerMsg']['errMsg']" :style="{ 
                'background-color': (consignmentSelection['lowerMsg']['status'] > 0 ? '' : '#b3ffc7'),
                'border': (consignmentSelection['lowerMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                {{ consignmentSelection['lowerMsg']['errMsg'] }}
              </div>
            </div>
          </div>
          <div class="depot" v-if="mode == 'Depot Booking'">
            <Dropdown :items="depotDropdownItems" :itemKey="'fullname'" :selectedObject.sync="depotDropdownSelected" placeholder="Depot" :isRequired="true"/>
          </div>
          <div class="functions">
            <button @click="hmsBtn('portreset', '')" :disabled="consignmentSelection['loading'] || !(consignmentSelection['upperSelected'] || consignmentSelection['lowerSelected'])">Reset</button>
            <button @click="verifyTrip()" :disabled="consignmentSelection['loading'] || !(consignmentSelection['upperSelected'] || consignmentSelection['lowerSelected']) || (mode == 'Depot Booking' ? !depotDropdownSelected : false)">Confirm</button>
          </div>
          <div class="note">
            Select both for {{consignmentSelection['upperLabel']}} &amp; {{consignmentSelection['lowerLabel']}} Job, else leave blank for single job. <br>
            e.g. Select ONLY {{consignmentSelection['upperLabel']}} for {{consignmentSelection['upperLabel'].toLowerCase()}} job.
          </div>
        </div>
      </div>
      <div class="hms-footer">
        <button @click="hmsBtn('portBookingClicked', '')" :disabled="hmsLoading || consignmentSelection['show'] || (consignmentSelection['select'] != '')">Port Booking</button>
        <button @click="hmsBtn('depotBookingClicked', 'selection')" :disabled="hmsLoading || consignmentSelection['show'] || (consignmentSelection['select'] != '')">Depot Booking</button>
        <button disabled>Dropoff In</button>
        <button disabled>...</button>
      </div>
      <div class="loader" v-if="consignmentSelection['loading']">
        <div class="load-text">{{ consignmentSelection['loadingMsg'] }}</div>
      </div>
    </div>
    <EntryPopup :show.sync="showBookingPopup" :title="consignmentBook['title']" :content.sync="consignmentBook['content']"
      :successMessages.sync="consignmentBook['successMessages']" :errorMessages.sync="consignmentBook['errorMessages']"
      :disabledSave="(this.consignmentBook['saved'] || this.consignmentBook['content']['popupData']['timeout'] <= 0)"
      :newStyle="true" :isComponent="true"
      @saved="entryPopupSaveClicked()" />
    <PopupEntry v-if="showPopupEntry" :show.sync="showPopupEntry" :title="popupEntryTitle" :createdBy="popupEntryCreatedBy" :updatedBy="popupEntryUpdatedBy" :messages="popupEntryMessages" :successMessages="popupEntrySuccessMessages" :errorMessages="popupEntryErrorMessages" :requiredError="popupEntryRequiredError" :viewMode="popupEntryViewMode" @save="popupEntrySaveClicked()" @requiredClicked="popupEntryRequiredClicked($event)" >
      <Loader :isVisible="popupEntryShowLoader" :loadingText="popupEntryLoaderText" />

      <div v-if="mode == 'Depot Booking'" class="portbook-main">

        <div class="portbook-timeout">
          Timeout: {{ formatDepotBookingTimeoutTime }}
        </div>

        <div class="portbook-timeout-cover" v-if="depotBookingTimeoutTime <= 0">
          <div class="title">Session Timed Out</div>
        </div>

        <div class="portbook-jobs">
          <div class="job-item" v-for="(j, i) in depotBookingJobs" :key="'job' + i">
            <div class="job-header">{{ j ? (j['ConsignmentNo'] ? j['ConsignmentNo'].trim() : '') : '' }}</div>

            <div class="job-row">
              <div class="title">
                <!-- <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'green' : 'red') }">Driver</div> -->
                <!-- <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/> -->
                <div class="title-text" style="color: green;">Driver</div>
                <img class="title-icon" src='https://dsmlib.logistics.systems/Icons/icons8-thumbs-up-96.png' alt=""/>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['DriverName'] ? j['DriverName'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['drivernric'] ? j['drivernric'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <!-- <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'green' : 'red') }">Vehicle Head</div> -->
                <!-- <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/> -->
                <div class="title-text" style="color: green;">Vehicle Head</div>
                <img class="title-icon" src='https://dsmlib.logistics.systems/Icons/icons8-thumbs-up-96.png' alt=""/>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['PMCode'] ? j['PMCode'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['PMNo'] ? j['PMNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <div class="title-text">Trailer</div>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['TRCode'] ? j['TRCode'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['TRNo'] ? j['TRNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <div class="title-text">Container(s)</div>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['ContainerNo'] ? j['ContainerNo'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['B2BContainerNo'] ? j['B2BContainerNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="portbook-functions">
          <div class="timeslot-details">
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Total</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['total'] ? depotBookingSelectedTimeslot['total'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Available</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['available'] ? depotBookingSelectedTimeslot['available'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Used</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['used'] ? depotBookingSelectedTimeslot['used'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>

            <div class="timeslot-row" style="width: 100%;">
              <div class="title">
                <div class="title-text">Timeslot Date/Time</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['start'] ? ('Start : ' + depotBookingSelectedTimeslot['start'].toString().trim()) : '-') : '-' }}</div>
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['end'] ? ('End   : ' + depotBookingSelectedTimeslot['end'].toString().trim()) : '-') : '-' }}</div>
              </div>
            </div>
          </div>

          <Input placeholder="Depot" :isDisabled="true" :inputValue="depotBookingDepotInput"/>
          <Dropdown ref="depotBookingTimeslotDropdown" placeholder="Timeslot" :isDisabled="popupEntryViewMode" :items="depotBookingTimeslots" itemKey="start" :selectedObject.sync="depotBookingSelectedTimeslot" :isRequired="true"/>
          <Dropdown ref="depotBookingOperatorDropdown" placeholder="Operator" :isDisabled="popupEntryViewMode" :items="depotDropdownSelected['operators']" itemKey="operator" :selectedObject.sync="depotBookingSelectedOperator" :isRequired="true"/>
          <RemarksBox class="portbook-remarks" title="Remarks" :isDisabled="popupEntryViewMode" :maxLength="300" :text.sync="depotBookingRemarks" />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
/* eslint-disable */
import EntryPopup from '@/components/EntryPopup.vue';
import PopupEntry from '@/components/PopupEntry.vue';

export default {
  components: {
    EntryPopup, PopupEntry,
  },
  data: function() {
    return {
      ganttMainWidth: 0,
      loading: false,
      loadText: 'Loading',

      startDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00`),
      endDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:59`),

      ganttItems: [],
      legendsItems: [],

      showHmsTrip: false, // screen showing all trips, right before clicking Port Booking / Depot Booking
      hmsTitle: '',
      hmsLoading: false,
      hmsTrips: [],
      consignmentDetails: null,

      showRefreshDropdown: false,
      refreshTime: 0,
      refreshTimeStart: 0,
      refreshInterval: null,

      lastRefresh: '',

      // consignmentSelection: {
      //   'show': false,
      //   'export': null,
      //   'import': null,
      //   'loading': false,
      //   'loadingMsg': 'Verifying',

      //   'select': '',
      //   'portbookType': '',

      //   'exportMsg': { 'status': 0, 'errMsg': '' },
      //   'importMsg': { 'status': 0, 'errMsg': '' },
      // },
      mode: '', // 'Port Booking' or 'Depot Booking'
      consignmentSelection: {
        'show': false,
        'upperLabel': '', // Export for port booking / Dropoff for depot booking
        'upperSelected': null,
        'lowerLabel': '', // Import for port booking / Pickup for depot booking
        'lowerSelected': null,
        'loading': false,
        'loadingMsg': 'Verifying',

        'select': '', // export/import/dropoff/pickup, depends on what the user last selected
        'portbookType': '', // upperlower/upper/lower
        // the reason there's a difference between select and portbookType
        // select is mainly used for display in the template
        // portbookType is used in the JavaScript portion
        // portbookType is usually used with string interpolation to easily refer to upperSelected, lowerSelected, lowerMsg and so on

        'upperMsg': { 'status': 0, 'errMsg': '' },
        'lowerMsg': { 'status': 0, 'errMsg': '' },
      },

      // data fields for Dropdown in div.consignment-selection.depot
      depotDropdownItems: [],
      depotDropdownSelected: null,

      consignmentBook: { // used for port booking, passed to EntryPopup
        'show': false,
        'title': '',
        'content': { type: 'PortBookingv2', popupData: { 'timeout': 300, 'loadText': '', 'jobs': [] }}, // use the PortBookingV2 component imported in EntryPopup
        'timeoutInterval': null, // used to store the interval ID returned by setInterval

        'saved': false,

        'successMessages': [],
        'errorMessages': [],
      },
      showBookingPopup: false, // show EntryPopup

      // PopupEntry data fields
      showPopupEntry: false,
      popupEntryShowLoader: false,
      popupEntryLoaderText: 'PopupEntry Loader Text',
      popupEntryTitle: '',
      popupEntryCreatedBy: '', // blank by default, so that the box on the top right won't show
      popupEntryUpdatedBy: '', // blank by default, so that the box on the top right won't show
      popupEntryMessages: [],
      popupEntrySuccessMessages: [],
      popupEntryErrorMessages: [],
      popupEntryRequiredError: [],
      popupEntryViewMode: false,

      // depot booking popupentry data fields
      depotBookingTimeoutTime: 300, // time before timeout in seconds
      depotBookingTimeoutInterval: null, // stores interval ID returned by setInterval, needed for clearInterval later on
      depotBookingJobs: [], // stores consignment details to be displayed inside PopupEntry, can either contain a Dropoff job only, a Pickup job only, or a Dropoff and Pickup job
      depotBookingDepotInput: '', // bound to the Input component in PopupEntry, the Input component is disabled and is only used to display this value
      depotBookingTimeslots: [], // bound to the timeslots Dropdown in PopupEntry
      depotBookingSelectedTimeslot: null, // bound to the timeslots Dropdown in PopupEntry
      depotBookingSelectedOperator: null, // bound to the operators Dropdown in PopupEntry
      depotBookingRemarks: '', // bound to RemarksBox in PopupEntry
    }
  },
  props: {
  },
  computed: {
    refreshText: function() {
      if (!this.refreshInterval) { return 'Refresh' }
      else {
        let totalSeconds = this.refreshTime;
        let inMinute = Math.floor(totalSeconds / 60);

        if (totalSeconds >= 60) {
          return `Refresh in ${inMinute} minute${inMinute > 1 ? 's' : ''}`;
        } else {
          return `Refresh in ${this.refreshTime} seconds`;
        }
      }
    },
    formatDepotBookingTimeoutTime: function() { // formats timeout seconds to XX:xx
      let minutes = Math.floor(this.depotBookingTimeoutTime / 60);
      let seconds = this.depotBookingTimeoutTime % 60;

      return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
  },
  methods: {
    getGanttDetails: async function() {
      this.loading = true;
      this.loadText = 'Getting Details';

      this.ganttItems = [];
      this.ganttItems = await this.$apiCallV2(`/VehicleSchedule/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.startDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.endDate, 'yyyy-MM-dd HH:mm')}&viewType=TEAM_PM`);
      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

      this.loading = false;

      if (this.refreshTimeStart > 0) {
        this.refreshIntervalClicked(null, this.refreshTimeStart);
      }
    },
    ganttTaskClicked: function(e) {
      console.log('from vspage', e);
    },
    ganttRowClicked: async function(e) {
      //-- Reset port booking
      this.$set(this.consignmentSelection, 'show', false);
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'select', '');

      //-- Get Pending Trips
      this.hmsTrips = [];

      this.showHmsTrip = true; // screen showing all trips, right before clicking Port Booking / Depot Booking
      this.hmsTitle = `${e[0]['ccol1text'].split('-')[0]} (${e[0]['ccol1text'].split('-')[1]}) - ${e[0]['ccol2text'].split('[').join('').split(']').join('')}`;
      let driverID = e[0]['ccol2text'].split('[')[1].split(']')[0];

      this.hmsLoading = true;
      let hmsTrip = await this.$apiCallV2(`/VehicleSchedule/GetHMSTripsByDriver?driver=${driverID}`);
      if (Array.isArray(hmsTrip)) {
        this.hmsTrips = hmsTrip;
      } else { console.log(hmsTrip) }
      this.hmsLoading = false;
      console.log(this.hmsTrips);
    },
    showConsignmentDetails: function(details) { // switch to the details screen
      // this.hmsTitle = details['ConsignmentNo'] ? details['ConsignmentNo'].trim() : '';
      this.consignmentDetails = details; // the screen automatically shows if consignmentDetails is not null
    },
    hideConsignmentDetails: function() {
      //-- Reset Port Booking (with conditions)
      // console.log(this.consignmentSelection['show']);
      // console.log(this.consignmentSelection['select']);
      if (!this.consignmentSelection['show'] && !this.consignmentDetails) {
        this.$set(this.consignmentSelection, 'show', true);
        this.$set(this.consignmentSelection, 'select', '');
      } else if (this.consignmentSelection['select'] == '' && !this.consignmentDetails) {
        this.$set(this.consignmentSelection, 'show', false);
        this.$set(this.consignmentSelection, 'upperSelected', null);
        this.$set(this.consignmentSelection, 'lowerSelected', null);
        this.$set(this.consignmentSelection, 'select', '');
        this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
        this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
      }
      
      //-- Close details
      this.consignmentDetails = null; // the screen automatically hides if consignmentDetails is null
    },
    formatConsignmentDetailsAddress: function(type) { // formats ToAddress and FromAddress displayed on the consignment details screen
      // address needs to be formatted as:
      // ToAddress
      // PostCode City, State, Country
      
      // type passed into the method is either 'From' or 'To'
      // use string interpolation to get field to access

      let address = this.consignmentDetails[`${type}Address`] ? this.consignmentDetails[`${type}Address`].replace(/\r/g, '<br>').trim() : '<br>';
      // replace all \r in address with a line break (<br>)
      address += address.endsWith('<br>') ? '' : '<br>';
      // if address already ends with a line break, don't add another one

      address += this.consignmentDetails[`${type}PostCode`] ? `${this.consignmentDetails[type + 'PostCode']} ` : '';
      address += this.consignmentDetails[`${type}City`] ? `${this.consignmentDetails[type + 'City']}, ` : (this.consignmentDetails[`${type}PostCode`] ? ', ' : '');
      // don't add a comma if there is no PostCode and City
      
      address += this.consignmentDetails[`${type}State`];
      address += this.consignmentDetails[`${type}State`] ? `, ${this.consignmentDetails[type + 'Country']}` : this.consignmentDetails[type + 'Country'];
      // if state isn't blank, add a comma and append country, else just add country

      return address;
      // in the HTML template, the returned string is placed inside a v-html tag, so Vue.js treats it as HTML instead of a plain string and renders it accordingly
    },
    refreshCountdown: function() {
      this.refreshTime--;
      if (this.refreshTime < 0) {
        this.refreshTime = this.refreshTimeStart;
      } else if (this.refreshTime == 0) {
        this.getGanttDetails();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    refreshIntervalClicked: function(e, seconds) {
      if (seconds) {
        this.refreshTime = seconds;
        if (e) { this.refreshTimeStart = seconds };
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(this.refreshCountdown, 1000);
      } else {
        if (e) {
          this.getGanttDetails();
        } else {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
          this.refreshTimeStart = 0;
        }
      }

      this.showRefreshDropdown = false;
    },

    //-- HMS view methods
    hmsHideTrip(trip) { // determines whether to hide a trip or not on the consignment selection screen
      var trigger = false; // hide if it has already been selected

      if (this.consignmentSelection['upperSelected']) {
        if ((this.consignmentSelection['upperSelected']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['upperSelected']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }

      if (this.consignmentSelection['lowerSelected']) {
        if ((this.consignmentSelection['lowerSelected']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['lowerSelected']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }

      return trigger;
    },

    //-- HMS Port Booking methods
    hmsBtn: async function(cmd, data) {
      switch(cmd) {
        case 'portBookingClicked': // port booking button clicked
          this.mode = 'Port Booking'; // populate fields accordingly and show consignment selection screen
          this.$set(this.consignmentSelection, 'upperLabel', 'Export');
          this.$set(this.consignmentSelection, 'upperSelected', null);
          this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
          this.$set(this.consignmentSelection, 'lowerLabel', 'Import');
          this.$set(this.consignmentSelection, 'lowerSelected', null);
          this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
          this.$set(this.consignmentSelection, 'show', true);
          this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
          this.$set(this.consignmentBook, 'timeoutInterval', null);
          break;

        case 'depotBookingClicked': // depot booking button clicked
          if (this.depotDropdownItems.length == 0) { // if this is the first time user clicked on depot booking
            this.$set(this.consignmentSelection, 'loadingMsg', 'Getting Depots');
            this.$set(this.consignmentSelection, 'loading', true);

          
            let GetCMRecordsResponse = await this.$apiCallV2('/VehicleSchedule/GetCMRecords');
            if (GetCMRecordsResponse.length == 0) {
              this.$showAlert('error', 'No Available Depot', 'Please try again later');
              this.$set(this.consignmentSelection, 'loading', false);
              return;
            } else {
              this.depotDropdownItems = GetCMRecordsResponse['depots'].map((depot) => {
                return {
                  'name': depot['name'],
                  'fullname': depot['fullname'],
                  'operators': depot['operators'].map((operator) => { return {'operator':operator} })
                };
              });
            }

            // call API to get Depots
            console.log(GetCMRecordsResponse);
            // populate Dropdown items

            // only call the API to get Depots the first time depot booking is clicked
            // subsequent depot booking clicks won't call the API again

            this.$set(this.consignmentSelection, 'loading', false);
          }

          this.mode = 'Depot Booking'; // populate fields accordingly and show consignment screen
          this.$set(this.consignmentSelection, 'upperLabel', 'Dropoff');
          this.$set(this.consignmentSelection, 'upperSelected', null);
          this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
          this.$set(this.consignmentSelection, 'lowerLabel', 'Pickup');
          this.$set(this.consignmentSelection, 'lowerSelected', null);
          this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
          this.$set(this.consignmentSelection, 'show', true);
          this.depotDropdownSelected = null; // clear Dropdown selected item if any
          
          break;

        case 'showTrips': // lists out trips to be selected
          if (!this.consignmentDetails) { // if not showing consignment details
            switch (data) {
              case 'upper':
                this.$set(this.consignmentSelection, 'select', (this.mode == 'Port Booking') ? 'export' : 'dropoff');
                break;

              case 'lower':
                this.$set(this.consignmentSelection, 'select', (this.mode == 'Port Booking') ? 'import' : 'pickup');
                break;
            }
            this.$set(this.consignmentSelection, 'show', false);
            this.$set(this.consignmentSelection, data + 'Msg', { 'status': 0, 'errMsg': '' });
          }
          break;
        case 'tripClicked': // trip selected
          if (this.consignmentSelection['select'] && !this.consignmentDetails) {
            this.$set(this.consignmentSelection, (this.consignmentSelection['select'] == 'export' || this.consignmentSelection['select'] == 'dropoff') ? 'upperSelected' : 'lowerSelected' , data);

            this.$nextTick(() => {
              this.$set(this.consignmentSelection, 'select', '');
              this.$set(this.consignmentSelection, 'show', true);
            });
          }
          break;
        case 'portreset': // clear selected, either upper only, lower only, or both
          switch(data) {
            case 'upper': // cross next to upperSelected is clicked
              this.$set(this.consignmentSelection, 'upperSelected', null);
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
              break;
            case 'lower': // cross next to lowerSelected is clicked
              this.$set(this.consignmentSelection, 'lowerSelected', null);
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
              break;
            default: // reset button is clicked
              this.$set(this.consignmentSelection, 'upperSelected', null);
              this.$set(this.consignmentSelection, 'lowerSelected', null);
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
              this.depotDropdownSelected = null;
              break;
          }
          break;
      }
    },
    verifyTrip: async function() { // verify that the trips selected are valid for booking
      switch (this.mode) { // the button is used for both port booking and depot booking
        case 'Port Booking': // if the user is performing a port booking
          this.$set(this.consignmentSelection, 'portbookType', `${this.consignmentSelection['upperSelected'] ? 'upper' : ''}${this.consignmentSelection['lowerSelected'] ? 'lower' : ''}`);

          this.$nextTick(async () => {
            this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
            this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
            this.$set(this.consignmentBook['content'], 'popupData', { 'timeout': 300, 'loadText': '', 'jobs': [] });

            //-- Set Loading
            this.$set(this.consignmentSelection, 'loadingMsg', 'Verifying');
            this.$set(this.consignmentSelection, 'loading', true);

            switch(this.consignmentSelection['portbookType']) {
              case 'upperlower':
                //-- Set variables
                var reqCount = 0;

                //-- Verify Data (export)
                var dataToPostExport = {
                  'server': 'production',
                  'journeyguid': this.consignmentSelection['upperSelected']['JourneyGUID'] ? this.consignmentSelection['upperSelected']['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': 'export',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }
                
                console.log('%cPost Data Export', 'color: hotpink', dataToPostExport);
              
                var requestExport = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPostExport);
                console.log(requestExport);

                //-- Verify Data (import)
                var dataToPostImport = {
                  'server': 'production',

                  'journeyguid': this.consignmentSelection['lowerSelected']['JourneyGUID'] ? this.consignmentSelection['lowerSelected']['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': 'import',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }
                
                console.log('%cPost Data Import', 'color: hotpink', dataToPostImport);
              
                var requestImport = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPostImport);
                console.log(requestImport);

                //-- Check incoming data
                //-- EXPORT
                if (!Array.isArray(requestExport) && (typeof requestExport == 'object')) {
                  this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': 'Confirmed' });
                  reqCount += 1;
                } else if (Array.isArray(requestExport)) {
                  if (requestExport[0]['Results'] > 0) {
                    console.log(requestExport[0]['ErrMsg']);
                    this.$set(this.consignmentSelection, 'upperMsg', { 'status': 1, 'errMsg': requestExport[0]['ErrMsg'] });
                  }
                }

                //-- IMPORT
                if (!Array.isArray(requestImport) && (typeof requestImport == 'object')) {
                  this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': 'Confirmed' });
                  reqCount += 1;
                } else if (Array.isArray(requestImport)) {
                  if (requestImport[0]['Results'] > 0) {
                    console.log(requestImport[0]['ErrMsg']);
                    this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 1, 'errMsg': requestImport[0]['ErrMsg'] });
                  }
                }

                if (reqCount >= 2) {
                  //-- Set Popup title
                  var impExp = 'EXP';
                  var consignmentNo = this.consignmentSelection['upperSelected']['ConsignmentNo'] ? this.consignmentSelection['upperSelected']['ConsignmentNo'].trim() : 'Consignment #';
                  var containerNo = this.consignmentSelection['upperSelected']['ContainerNo'] ? this.consignmentSelection['upperSelected']['ContainerNo'].trim() : 'Container #';

                  var title = 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                  impExp = 'IMP';
                  consignmentNo = this.consignmentSelection['lowerSelected']['ConsignmentNo'] ? this.consignmentSelection['lowerSelected']['ConsignmentNo'].trim() : 'Consignment #';
                  containerNo = this.consignmentSelection['lowerSelected']['ContainerNo'] ? this.consignmentSelection['lowerSelected']['ContainerNo'].trim() : 'Container #';

                  title += '[' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                  this.$set(this.consignmentBook, 'title', title);
                  
                  //-- Set Popup data
                  this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection['upperSelected'], requestExport), Object.assign({}, this.consignmentSelection['lowerSelected'], requestImport)]);

                  //-- Set Popup show
                  this.showBookingPopup = true;
                  // this.$set(this.consignmentBook, 'show', true);
                  this.$set(this.consignmentBook, 'saved', false);
                  this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                  
                  //-- Clear Interval or Reset
                  clearInterval(this.consignmentBook['timeoutInterval']);
                  this.$set(this.consignmentBook, 'timeoutInterval', null);
                  this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                    if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                      this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                    } else {
                      clearInterval(this.consignmentBook['timeoutInterval']);
                      this.$set(this.consignmentBook, 'timeoutInterval', null);
                    }
                  }, 1000));
                }

                break;
              case 'upper':
              case 'lower':  
                //-- Verify Data (export OR import)
                var dataToPost = {
                  'server': 'production',

                  'journeyguid': this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': this.consignmentSelection['portbookType'] == 'upper' ? 'export' : 'import',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }
                
                console.log('%cPost Data', 'color: hotpink', dataToPost);
              
                var request = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPost);
                console.log(request);

                //-- Check incoming data
                if (!Array.isArray(request) && (typeof request == 'object')) {
                  this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 0, 'errMsg': 'Confirmed' });

                  //-- Set Popup title
                  var impExp = ((this.consignmentSelection['portbookType'] == 'upper') ? 'EXP' : 'IMP');
                  var consignmentNo = this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ConsignmentNo'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ConsignmentNo'].trim() : 'Consignment #';
                  var containerNo = this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ContainerNo'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ContainerNo'].trim() : 'Container #';

                  this.$set(this.consignmentBook, 'title', 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ');
                  
                  //-- Set Popup data
                  this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`], request)]);

                  //-- Set Popup show
                  this.showBookingPopup = true;
                  // this.$set(this.consignmentBook, 'show', true);
                  this.$set(this.consignmentBook, 'saved', false);  
                  this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                  
                  //-- Clear Interval or Reset
                  clearInterval(this.consignmentBook['timeoutInterval']);
                  this.$set(this.consignmentBook, 'timeoutInterval', null);
                  this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                    if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                      this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                    } else {
                      clearInterval(this.consignmentBook['timeoutInterval']);
                      this.$set(this.consignmentBook, 'timeoutInterval', null);
                    }
                  }, 1000));

                } else if (Array.isArray(request)) {
                  if (request[0]['Results'] > 0) {
                    console.log(request[0]['ErrMsg']);
                    this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 1, 'errMsg': request[0]['ErrMsg'] });
                  }
                }
                break;
            }

            //-- Set Loading
            this.$set(this.consignmentSelection, 'loading', false);
          });

          break;

        case 'Depot Booking': // if the user is performing a depot booking

          this.$set(this.consignmentSelection, 'loadingMsg', 'Verifying'); // show loader
          this.$set(this.consignmentSelection, 'loading', true);

          this.popupEntryTitle = 'Depot Booking - '; // format title
          this.depotBookingJobs = [];

          if (this.consignmentSelection['upperSelected']) { // if a dropoff trip is selected
          let portBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', {
              'journeyguid': this.consignmentSelection['upperSelected']['JourneyGUID'],
              'depot': this.depotDropdownSelected['name'],
              
              'action': '',
              'bookingtype': '',
              'addjourneyguid': '',
              'operator': '',
              'timeslot': '',
              'notes': ''
            });

            if (!Array.isArray(portBookingResponse) && (typeof portBookingResponse == 'object') && !portBookingResponse['ErrMsg']) { // received data is not an array, is a JSON object and does not contain an 'ErrMsg' field or 'ErrMsg' field is blank
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': 'Confirmed' });
              this.popupEntryTitle += `[DROP][${this.consignmentSelection['upperSelected']['ConsignmentNo'].trim()}][${this.consignmentSelection['upperSelected']['ContainerNo'].trim()}] `;
              this.depotBookingJobs.push(this.consignmentSelection['upperSelected']);
              this.depotBookingDepotInput = portBookingResponse['info']['fullname'] ? portBookingResponse['info']['fullname'] : portBookingResponse['info']['shortname'];
              this.depotBookingTimeslots = portBookingResponse['slots'];
            } else if (Array.isArray(portBookingResponse) && portBookingResponse[0]['ErrMsg']) { // received data is an array and the 'ErrMsg' field is not blank
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 1, 'errMsg': portBookingResponse[0]['ErrMsg'] });
            }
            
          }

          if (this.consignmentSelection['lowerSelected']) { // if a pickup trip is selected
            let portBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', {
              'journeyguid': this.consignmentSelection['lowerSelected']['JourneyGUID'],
              'depot': this.depotDropdownSelected['name'],
              
              'action': '',
              'bookingtype': '',
              'addjourneyguid': '',
              'operator': '',
              'timeslot': '',
              'notes': ''
            });
            

            if (!Array.isArray(portBookingResponse) && (typeof portBookingResponse == 'object') && !portBookingResponse['ErrMsg']) { // received data is not an array, is a JSON object and does not contain an 'ErrMsg' field or 'ErrMsg' field is blank
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': 'Confirmed' });
              this.popupEntryTitle += `[PICK][${this.consignmentSelection['lowerSelected']['ConsignmentNo'].trim()}][${this.consignmentSelection['lowerSelected']['ContainerNo'].trim()}] `;
              this.depotBookingJobs.push(this.consignmentSelection['lowerSelected']);
              this.depotBookingTimeslots = portBookingResponse['slots'];
            } else if (Array.isArray(portBookingResponse) && portBookingResponse[0]['ErrMsg']) { // received data is an array and the 'ErrMsg' field is not blank
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 1, 'errMsg': portBookingResponse[0]['ErrMsg'] });
            }
          }

          this.$set(this.consignmentSelection, 'loading', false);

          if (this.consignmentSelection['upperMsg']['status'] != 0 || this.consignmentSelection['lowerMsg']['status'] != 0) // if either dropoff or pickup is invalid
            return; // exit function

          this.depotBookingSelectedTimeslot = null;
          this.depotBookingSelectedOperator = null;
          this.depotBookingRemarks = '';
          this.popupEntryViewMode = false;
          this.popupEntryClearMessages();


          this.depotBookingTimeoutTime = 300; // timeout after 300 seconds (5 minutes)
          this.depotBookingTimeoutInterval = setInterval(() => {
            if (--this.depotBookingTimeoutTime <= 0) { // prefix decrement, decrement value first before checking if less than or equal to 0
              clearInterval(this.depotBookingTimeoutInterval);
              this.popupEntryViewMode = true;
            }
          }, 1000);

          this.showPopupEntry = true;
          break;
      }
    },
    entryPopupSaveClicked: async function() { // save port booking (right now only Port Booking uses EntryPopup)
      this.$set(this.consignmentBook, 'successMessages', []);
      this.$set(this.consignmentBook, 'errorMessages', []);

      console.log(this.consignmentBook['content']['popupData']['jobs']);
      
      if (this.consignmentBook['content']['popupData']['jobs'].filter((d, i) => { return d['timeslotsSel']; })['length'] > 0) {
        //-- Get data of 1st item
        var jobData = this.consignmentBook['content']['popupData']['jobs'][0];

        //-- Save Data (Final, or known as 2nd API call)
        var dataToPost = {
          'server': 'production',
          'journeyguid': (this.consignmentSelection['portbookType'] == 'upperlower') ? (this.consignmentSelection['upperSelected']['JourneyGUID'] ? this.consignmentSelection['upperSelected']['JourneyGUID'].trim() : '') : (this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'].trim() : ''),
          'addjourneyguid': (this.consignmentSelection['portbookType'] == 'upperlower') ? (this.consignmentSelection['lowerSelected']['JourneyGUID'] ? this.consignmentSelection['lowerSelected']['JourneyGUID'].trim() : '') : '',
          'bookingtype': this.consignmentSelection['portbookType'] == 'upperlower' ? 'exportimport' : (this.consignmentSelection['portbookType'] == 'upper' ? 'export' : 'import'),
          'action': 'N',
          'terminal': (jobData ? (jobData['usecontterminal'] ? jobData['usecontterminal'].trim() : '') : ''),
          'timeslot': (jobData ? (jobData['timeslotsSel'] ? jobData['timeslotsSel']['start'].trim() : '') : ''),
          'notes': (jobData ? (jobData['remarks'] ? jobData['remarks'].trim() : '') : ''),
        }
        
        console.log('%cPost Data', 'color: hotpink', dataToPost);
        this.$set(this.consignmentBook['content']['popupData'], 'loadText', 'Saving');

        var request = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPost);
        console.log(request);
        
        if (Array.isArray(request)) {
          if (request[0]['Results'] <= 0) {
            console.log('%cPortB Success', 'color: green;', request);
            
            this.$set(this.consignmentBook, 'successMessages', ['Booking successful.']);
            this.$set(this.consignmentBook, 'saved', true);
          } else { 
            console.log('%cPortB Error', 'color: red;', request[0]['ErrMsg']);

            this.$set(this.consignmentBook, 'errorMessages', [request[0]['ErrMsg']]);
          }

        } else if (typeof request == 'object') {
          console.log('%cPortB Success', 'color: green;', request);
        } else {
          console.log('%cPortB Error', 'color: red;', request);

          this.$set(this.consignmentBook, 'errorMessages', [request]);
        }

        this.$set(this.consignmentBook['content']['popupData'], 'loadText', '');
      } else {
        this.$set(this.consignmentBook, 'errorMessages', ['No timeslot was selected, please select a timeslot.']);
      }
    },
    popupEntryClearMessages: function() { // clear all messages shown on PopupEntry
      this.popupEntryMessages = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryErrorMessages = [];
      this.popupEntryRequiredError = [];
    },
    popupEntrySaveClicked: async function() {
      switch (this.mode) {
        case 'Depot Booking': // right now, only Depot Booking uses PopupEntry, add other branches once more functionality has been added
          this.popupEntryClearMessages();

          if (!this.depotBookingSelectedTimeslot)
            this.popupEntryRequiredError.push({'Key':'timeslot', 'Value':'Please select a timeslot'});
          
          if (!this.depotBookingSelectedOperator)
            this.popupEntryRequiredError.push({'Key':'operator', 'Value':'Please select an operator'});
          
          if (this.popupEntryRequiredError.length > 0) // if either timeslot or operator is blank
            return; // exit function

          let portBookingRequestBody = {   
            'action': 'N',
            'bookingtype': '',
            'journeyguid': '',
            'addjourneyguid': '',
            'depot': this.depotDropdownSelected['name'],
            'timeslot': this.depotBookingSelectedTimeslot['start'].trim(),
            'operator': this.depotBookingSelectedOperator['operator'].trim(),
            'notes': this.depotBookingRemarks.trim()
          };

          if (this.depotBookingJobs.length == 2) { // dropoff & pickup
            portBookingRequestBody['bookingtype'] = 'droppickup';
            portBookingRequestBody['journeyguid'] = this.consignmentSelection['upperSelected']['JourneyGUID'];
            portBookingRequestBody['addjourneyguid'] = this.consignmentSelection['lowerSelected']['JourneyGUID'];
          } else if (this.consignmentSelection['upperSelected']) { // dropoff only
            portBookingRequestBody['bookingtype'] = 'drop';
            portBookingRequestBody['journeyguid'] = this.consignmentSelection['upperSelected']['JourneyGUID'];
          } else { // pickup only
            portBookingRequestBody['bookingtype'] = 'pickup';
            portBookingRequestBody['journeyguid'] = this.consignmentSelection['lowerSelected']['JourneyGUID'];
          }


          let portBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', portBookingRequestBody);

          if (Array.isArray(portBookingResponse)) { // copied from save port booking and modified accordingly
            if (portBookingResponse[0]['Results'] == 0) {
              this.popupEntrySuccessMessages.push('Booking successful.');
              this.popupEntryViewMode = true;
              // this.$set(this.consignmentBook, 'successMessages', ['Booking successful.']);
              // this.$set(this.consignmentBook, 'saved', true);
            } else { 
              this.popupEntryErrorMessages.push(portBookingResponse[0]['ErrMsg']);
              // this.$set(this.consignmentBook, 'errorMessages', [request['data'][0]['ErrMsg']]);
            }
            // sus
          } else if (typeof request == 'object') {
            // console.log('%cPortB Success', 'color: green;', request['data']);
            this.popupEntrySuccessMessages.push('Booking successful.');
            this.popupEntryViewMode = true;
          } else {
            // console.log('%cPortB Error', 'color: red;', request['data']);
            this.popupEntryErrorMessages.push(portBookingResponse[0]['ErrMsg']);
            // this.$set(this.consignmentBook, 'errorMessages', [request['data']]);
          }
          break;
      }
    },
    popupEntryRequiredClicked: function(event) { // called when a required message shown in PopupEntry is clicked
      switch (this.mode) {
        case 'Depot Booking':
          
          switch (event) {
            case 'timeslot':
              this.$refs['depotBookingTimeslotDropdown'].setFocus(); // expand timeslot dropdown in popupentry
              break;

            case 'operator':
              this.$refs['depotBookingOperatorDropdown'].setFocus(); // expand operator dropdown in popupentry
              break;
          }

          break;
      }
    },
  },
  async mounted() {
    await this.getGanttDetails();
    
    this.loading = true;
    this.loadText = 'Getting Legends';
    this.legendsItems = await this.$apiCallV2('/VehicleSchedule/GetLegends?viewType=TEAM_PM');

    this.loading = false;
  },
  watch: {
    showHmsTrip : function(val) {
      setTimeout(() => {
        this.ganttMainWidth = this.$refs['gantt-container'].getBoundingClientRect().width - 115;
      }, 300);
      
    },
    showBookingPopup: function(val) {
      if (this.refreshInterval) {
        if (val) {
          clearInterval(this.refreshInterval);
        } else {
          this.refreshIntervalClicked(null, this.refreshTime);
        }
      }
    },
    // depotDropdownSelected: function(val) {
    //   console.log('depotDropdownSelected updated');
    //   console.log(this.depotDropdownSelected);
    // },
    // consignmentSelection: { deep: true, handler(h) { 
    //     console.log('consigmentSelection updated');
    //     console.log(this.consignmentSelection['upperSelected']);
    //     console.log(this.consignmentSelection['lowerSelected']);
    //   }
    // },
    depotBookingSelectedTimeslot: function(val) {
      this.depotBookingSelectedOperator = null;
      // console.log('timeslot updated');
      // console.log(this.depotBookingSelectedTimeslot);
    },
    // depotBookingSelectedOperator: function(val) {
    //   console.log('operator updated');
    //   console.log(this.depotBookingSelectedOperator);
    // }
    // upperSelected: function(val) {
    //   console.log('upperSelected updated');
    //   console.log(this.upperSelected);
    // },
    // lowerSelected: function(val) {
    //   console.log('lowerSelected updated');
    //   console.log(this.lowerSelected);
    // },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.vehicle-schedule-main {
  width: 100%;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  > .gantt-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    position: relative;

    > .date-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 5px 0;

      > * {
        margin-left: 5px;
      }

      > .date-title {
        height: 100%;
        position: relative;
        top: 3px;
      }

      > .refresh-container {
        position: relative;
        min-width: 200px;

        > button {
          width: 100%;
        }

        > .refresh-dropdown {
          position: absolute;
          top: 100%;
          background-color: white;
          width: 100%;
          z-index: 10;
          padding: 5px;
          border-width: 1px;
          border-style: solid;
          border-color: transparent black black black;

          > button {
            width: 100%;
            border-radius: 0;
            padding: 3px;
          }

          > .refresh-now {
            margin: 5px 0;
          }

          > .cancel-refresh {
            background-color: red;
            color: white;
          }
        }
      }

      > .last-refresh {
        margin: 0 5px;
      }
    }

    > .gantt-with-legends {
      height: calc(100% - 40px);
      display: flex;

      > .gantt-legends {
        min-width: 100px;
        max-width: 100px;
        height: fit-content;
        font-size: 10px;
        margin-left: 5px;

        > .gantt-legends-items {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          > .gantt-legends-color {
            max-width: 20px;
            min-width: 20px;
            max-height: 20px;
            min-height: 20px;
            margin-right: 3px;
          }
        }
      }
    }

    > .gantt-loader {
      position: absolute;
      left: 0;
      top: 0 !important;
      height: 100% !important;
      width: 100%;
    }
  }

  > .vehicle-schedule-body {
    width: auto;
    height: 100%;
    padding: 5px;
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    overflow-x: scroll;

    > .portBPopup {
      width: auto;
      height: auto;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
  }

  > .hms-trip-container {
    background-color: white;
    padding: 0;
    border-radius: 5px;
    margin-left: 5px;
    width: 0;
    transition: 0.3s;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 98;

    > * {
      width: 100%;
      padding: 5px;
      display: flex;
    }

    > .hms-title {
      min-height: 30px;
      max-height: 30px;
      // background-color: #f24a01;
      align-items: center;
      color: white;
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      border-radius: 5px 5px 0 0;

      > .header-back-button {
        padding-left: 5px;
        padding-right: 10px;
        cursor: pointer;
      }
    }

    > .hms-body {
      height: 100%;
      background-color: #eaeaea;
      overflow: auto;

      > .loading-hms-trips {
        width: 100%;
        text-align: center;
      }

      > .hms-trips-container {
        width: 100%;
        
        > .hms-trips-content {
          background-color: white;
          border: 1px solid black;
          width: 100%;
          padding: 5px;
          margin-bottom: 5px;
          position: relative;
          padding-right: 25px;
          user-select: none;

          > .trips-row {
            display: flex;
            align-items: flex-start;

            > .trips-left {
              width: fit-content;
              flex-grow: 1;
              font-weight: bold;
              padding-right: 5px;
            }

            > .trips-right {
              // max-width: 100px;
              width: fit-content;
              text-align: right;
              white-space: nowrap;
            }
          }

          > .trips-tooltip {
            position: absolute;
            right: 3px;
            bottom: 3px;
          }
        }
      }

      > .consignment-details {
        width: 100%;

        > .consignment-row {
          display: flex;
          margin-bottom: 5px;

          > .consignment-label {
            min-width: 112px;
            font-weight: bold;
          }

          > .consignment-details-left {
            // flex-grow: 1;
            min-width: 150px;
          }

          > .consignment-details-right {
            flex-grow: 1;
            text-align: left;
            // font-weight: 900;
          }
        }
      }

      > .consignment-selection {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        > .consignment {
          width: 100%;
          display: flex;
          margin: 0 0 10px 0;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          border: solid 1px #42a81d;
          border-radius: 5px;
          
          > .title {
            width: 100%;
            height: 24px;
            padding: 0 5px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #42a81d;
            color: #ffffff;
            border-radius: 3px 3px 0 0;

            > .text {
              width: auto;
              height: 100%;
              padding: 0 5px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }

            > .cancel {
              width: 16px;
              height: 16px;
              padding: 0 0 2px 0;
              font-size: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #dddddd;
              user-select: none;
              cursor: pointer;
            }

            > .cancel:hover {
              color: #ffffff;
            }
          }

          > .content {
            width: 100%;
            padding: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            > .hms-trips-content {
              background-color: white;
              border: 1px solid black;
              width: 100%;
              padding: 5px;
              position: relative;
              padding-right: 25px;
              user-select: none;

              > .trips-row {
                display: flex;
                align-items: flex-start;

                > .trips-left {
                  width: fit-content;
                  flex-grow: 1;
                  font-weight: bold;
                  padding-right: 5px;
                }

                > .trips-right {
                  // max-width: 100px;
                  width: fit-content;
                  text-align: right;
                  white-space: nowrap;
                }
              }

              > .trips-tooltip {
                position: absolute;
                right: 3px;
                bottom: 3px;
              }
            }

            > .noselect {
              width: 100%;
              height: 65px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: solid 1px #0001;
              color: gray;
              user-select: none;
              cursor: pointer;
            }

            > .noselect:hover {
              border: solid 1px #0004;
            }

            > .errMsg { 
              width: 100%;
              height: auto;
              padding: 5px;
              margin: 5px 0 0 0;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              background-color: #ffd9d9;
              border: solid 1px red;
            }
          }
        }
        
        > .depot {
          width: 100%;
        }

        > .functions {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          
          > button {
            margin: 0 0 0 5px;
          }
        }

        > .note {
          width: 100%;
          height: auto;
          padding: 20px 0 0 0;
          font-size: 12px;
          color: gray;
          user-select: none;
        }
      }
    }
    

    > .hms-footer {
      min-height: 40px;
      max-height: 40px;
      background-color: #eaeaea;
      align-items: center;
      border-top: 1px solid rgba(64,64,64,0.5);

      > button {
        margin: 0 5px 0 0;
      }
    }

    > .loader {
      width: 410px;
      height: calc(100% - 30px);
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0004;
      z-index: 10;

      > .load-text {
        width: auto;
        height: auto;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 8px #0004;
        user-select: none;
      }
    }
  }
}

// PopupEntry Depot Booking styling
.portbook-main {
  width: 100%;
  height: 100%;
  // position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > .portbook-timeout {
    width: auto;
    height: 17.5px;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 3.5%;
    right: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  > .portbook-timeout-cover {
    width: calc(100% - 94px);
    height: calc(95% - 140px);
    position: absolute;
    // top: -5px;
    // bottom: -5px;
    // left: -5px;
    // right: -5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 10;

    > .title {
      width: auto;
      height: auto;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      user-select: none;
    }
  }

  > .portbook-jobs {
    width: 60%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .job-item {
      width: 100%;
      height: 100%;
      max-width: calc(50% - 2.5px);
      padding: 5px 5px 0 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      background-color: #eaeaea;
      border: solid 1px #0004;
      border-radius: 5px;

      > .job-header {
        width: 100%;
        height: 24px;
        margin: 0 0 5px 0;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;
      }

      > .job-row {
        width: 100%;
        height: auto; 
        padding: 2px 5px;
        margin: 0 0 5px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;

        > .title {
          width: 100%;
          height: 20px;
          margin: 0 0 2px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title-text {
            width: auto;
            height: 100%;
            flex: 1;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          > .title-icon {
            width: 20px;
            height: 20px;
            user-select: none;
          }
        }

        > .value {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          > .value-row {
            width: 100%;
            height: 15px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            white-space: pre;
          }
        }
      }
    }
  }

  > .portbook-functions {
    width: 40%;
    height: 100%;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    > .timeslot-details {
      width: 100%;
      height: auto; 
      padding: 5px 5px 0 5px;
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      background-color: #eaeaea;
      border: solid 1px #0004;
      border-radius: 5px;

      > .timeslot-row {
        width: calc(33% - 3.33px);
        height: auto; 
        padding: 2px 5px;
        margin: 0 0 5px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;

        > .title {
          width: 100%;
          height: 20px;
          margin: 0 0 2px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title-text {
            width: auto;
            height: 100%;
            flex: 1;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }

        > .value {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          > .value-row {
            width: 100%;
            height: 15px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            white-space: pre;
          }
        }
      }
    }

    > .portbook-remarks {
      width: 100%;
      max-height: 200px;
    }
  }
}
</style>